import {Button, Modal} from "react-bootstrap";
import {mediumTextStyles, regularErrorStyle, regularTextStyles} from "../Style";
import React, {useEffect, useState} from "react";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";

function SaveEmailQuote(props) {
    let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({});
    const {executeRecaptcha} = useGoogleReCaptcha();
  const [success, setSuccess] = useState(false);
  const [verificationFailedStep, setVerificationFailedStep] = useState('');
  const baseUrl = window.location.origin;
  const eventName = window.location.href.includes('car')
    ? 'carAutosureEvent'
    : window.location.href.includes('quashed')
      ? 'carQuashedEvent'
      : window.location.href.includes('better')
        ? 'carBetterEvent'
        : window.location.href.includes('simplify')
          ? 'carSimplifyEvent'
          : '';

  useEffect(() => {
    if (verificationFailedStep === 'sendEmail') {
      sendEmail().then(r => console.log("sendEmail"));
    }
  }, [props.inputValues.isRecaptchaV2Verified]);

    const handleClose = () => {

        props.setShowEmailPopup(false);
      setSuccess(false);
    };


    const sendEmail = async () => {
        let isError = false;
        const newErrors = {}
        if (!email || email === '') {
            newErrors.email = 'Please enter a valid email address'
            isError = true;
        } else if (email.length > 100) {
            newErrors.email = 'Email address too long.'
            isError = true;
        } else {
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
                newErrors.email = 'Is invalid';
                isError = true;
            }
        }

        if (!isError) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': `${eventName}`,
              'category': 'Email My Quote Submit',
              'status': 'Success',
              'virtualUrl': `${baseUrl}/vehicle/step3`,
              'pageTitle': 'Quote',
            });

          if (!executeRecaptcha) {
                console.log('reCAPTCHA is not ready');
                return;
            }
          let token = await executeRecaptcha('submit');
          if (props.inputValues.isRecaptchaV2Verified) {
            token = "AUTHENTICATED_V2"
          }
          const prospectData = {
                id: props.inputValues.id,
                email: email,
                "recaptchaResponse": token
            };

            fetch(`${url}/vero/prospects/email-quote`, {
                method: 'POST',
                mode: "cors",
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": 'By-Pass-Auth-Create-Prospect'
                },
                body: JSON.stringify(prospectData)
            })
              .then(async (response) => {
                if (response.status === 428) {
                  // Show fallback captcha for 428 status
                  console.log('Primary reCAPTCHA failed for sendEmail, showing fallback captcha');
                  //setIsSubmitting(false);
                  props.handleChangeValue("showRecaptchaPopup", true);
                  setVerificationFailedStep("sendEmail");
                  return;
                }
                if (response.status === 200) {
                  setSuccess(true);
                  // props.setShowEmailPopup(false);
                } else if (response.status === 500) {
                  setSuccess(false);
                  props.setShowEmailPopup(false);
                } else {
                  setSuccess(false);
                  props.setShowEmailPopup(false);
                }
              })
                .catch((e) => {
                  setSuccess(false);
                  props.setShowEmailPopup(false);
                });
        }
        setErrors(newErrors);
    };


    return (
        <>
            <Modal
                show={props.showEmailPopup}
                onHide={handleClose}

                backdrop="static"
                size="lg"
                keyboard={false}
            >
                <Modal.Header closeButton style={{backgroundColor: "slategrey"}}>
                    <Modal.Title className={mediumTextStyles}><span
                        style={{color: 'White'}}>Save this quote for later</span> </Modal.Title>
                </Modal.Header>

                <Modal.Body className={regularTextStyles}>
                    <p style={{textAlign: "center"}}>
                        We'll email your quote (don't worry, we won't use it for anything else). {errors.email}
                    </p>
                    <p style={{textAlign: "center"}}>
                        The quote is valid
                      until {} {new Date(new Date().setDate(new Date().getDate() + 30)).toLocaleDateString('en-GB')}.
                    </p>

                  <p style={{textAlign: "center"}}>
                        <input type="textbox" placeholder="e.g. jane.smith@example.com" size={30} value={email}
                               onChange={(e) => setEmail(e.target.value)}/>
                        <div style={regularErrorStyle}>
                            {errors.email}
                        </div>
                    </p>

                </Modal.Body>
                <Modal.Footer style={{justifyContent: "center"}}>
                  {!success &&
                    <Button variant="primary" onClick={sendEmail}>
                        Save and email this quote
                    </Button>
                  }
                  {
                    success &&
                    <div>
                      <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="Check circle">
                          <path
                            id="Icon"
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10.5 18.6C14.9183 18.6 18.5 15.0182 18.5 10.6C18.5 6.18168 14.9183 2.59996 10.5 2.59996C6.08172 2.59996 2.5 6.18168 2.5 10.6C2.5 15.0182 6.08172 18.6 10.5 18.6ZM14.2071 9.30707C14.5976 8.91654 14.5976 8.28338 14.2071 7.89285C13.8166 7.50233 13.1834 7.50233 12.7929 7.89285L9.5 11.1857L8.20711 9.89285C7.81658 9.50233 7.18342 9.50233 6.79289 9.89285C6.40237 10.2834 6.40237 10.9165 6.79289 11.3071L8.79289 13.3071C9.18342 13.6976 9.81658 13.6976 10.2071 13.3071L14.2071 9.30707Z"
                            fill="#54B444"
                          />
                        </g>
                      </svg>
                      Email sent!</div>
                  }
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default SaveEmailQuote;
